<template>
  <div class="nova-control-wrapper" v-if="selectItems.length">
    <label v-if="title">{{title}}</label>
    <div class="nova-select" ref="novaSelect">
      <div class="nova-select-input" @click="open">
        <div class="nova-select-value" :class="{'empty': !current}">
          <span v-if="current">{{ current.name }}</span>
          <span v-else>{{ label }}</span>
        </div>
        <!-- <div v-else class="nova-select-value">
          <span>{{value}}</span>
        </div> -->
        <span class="nova-select-angle ti-angle-down"></span>
      </div>
      <div class="nova-select-list">
        <ul>
          <li 
            v-for="(item, key) in selectItems" 
            :key="key" :class="{'active': item.value == value}" 
            @click="select(item)">
            <span>
              <template v-if="(typeof item != 'object')">
                {{ item }}
              </template>
              <template v-else>
                <span>{{ item.name ? item.name : item.value}}</span>
              </template>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
      inheritAttrs: true,
      name: "nova-select",
      props: {
          items: [Array, Object],
          title: String,
          label: {
            default: 'Не выбрано'
          },
          name: String,
          lang: String,
          onlyValue: Boolean,
          valueName: String,
          nameName: String,
          value: [String, Number],
          change: Function,
      },
      created(){
        // todo
        if(typeof this.items == 'object' && !Array.isArray(this.items)){
          console.log('зашел')
          for(let i in this.items){
            let obj = {
              value: i,
              name: this.items[i]
            }
            this.selectItems.push(obj)
          }
          console.log(this.selectItems, 'Вышло')
          return 
        }
        if(!this.items.length)
          return
        this.items.map((el, i) => {
          let value, name;
          if((typeof this.items[0] != 'object')){
            value = this.onlyValue ? el : i
            name = el
          }else{
            value = this.valueName ?  el[this.valueName] : el.value
            name = this.nameName ?  el[this.nameName] : el.name
          }

          let obj = { value, name }
          this.selectItems.push(obj)
        });
      },
      mounted(){
        console.log(this.selectItems.filter(e=>{return e.value == this.value}))
        setTimeout(() => {
          this.current = this.selectItems.filter(e=>{return e.value == this.value})[0]
        }, 1);
      },
      methods:{
        open(){
          console.log('open')
          this.$refs.novaSelect.classList.add("active")
          setTimeout(() => {
            document.body.addEventListener("click", this.close)
          }, 1);
        },
        close(){
          console.log('close', this.$refs.novaSelect)
          if(this.$refs.novaSelect)
            this.$refs.novaSelect.classList.remove("active")
          setTimeout(() => {
            document.body.removeEventListener("click", this.close)
          }, 1)
        },
        async select(item){
          console.log(item, 'item.value')
          this.$emit('input', item.value );
          this.$emit('change');
        
          console.log(item, 'item')
          if(this.current && this.current.value != item.value)
            this.animateEl()
          this.current = item
        },
        animateEl(){
          let el = this.$refs.novaSelect
          if(!el)
            return
            el.classList.add("animate")
          setTimeout(() => {
            el.classList.remove("animate")
          }, 200);
          console.log(el)
        }
      },
      data(){
        return {
          selectItems: [],
          current: null,
        }
      },
      computed: {

      }
  }
</script>
<style lang="scss">
.nova-select{
  position: relative;
  z-index: 1;
  .ti-angle-down{
    position: absolute;
    right: 20px;
    color: var(--color-1);
    transition: 0.2s ease;
  }
  &.animate{
    .nova-select-value{
      span{
        opacity: 0;
      }
      transform: scale(0);
    }
  }
  &.active{
    .nova-select-angle{
      transform: rotate(180deg);
    }
    .nova-select-input{
      box-shadow: 0 5px 12px rgba(0,0,0,0.15);
    }
    .nova-select-list{
      opacity: 1;
      pointer-events: auto;
      transform: translateY(0);
      ul{
        
      }
    }
  }
}
.nova-select-input{
  border-radius: 30px;
  border: 1px solid var(--color-1);
  background-color: white;
  padding: 7px 7px;
  height: 46px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
  transition: 0.2s ease;
  &:hover{
    cursor: pointer;
  }
}
.nova-select-value{
  min-width: 70px;
  padding: 4px 15px;
  height: 100%;
  background-color: var(--color-1);
  color: white;
  border-radius: 30px;
  transform: scale(1);
  transition: 0.2s ease;
  transform-origin: 10px 50%;
  &.empty{
    background-color: #b5b5b5;
  }
}
.nova-select-list{
  position: absolute;
  width: calc(100% - 24px);
  opacity: 0;
  pointer-events: none;
  transition: 0.2s ease;
  left: 12px;
  top: 100%;
  margin-top: -5px;
  transform: translateY(-10px);
  ul{
    // border: 1px solid var(--color-1);
    // background-color: white;
    box-shadow: 0 4px 10px rgba(0,0,0,0.25);
    border-radius: 0 0 30px 30px;
    overflow-y: auto;
    max-height: 200px;
    background-color: white;
  }
  li{
    padding: 15px 20px;
    background-color: white;
    position: relative;
    z-index: 1;
    transition: 0.2s ease;
    // border-radius: 20px;
    &.active{
      // color: white;
      font-weight: 600;
      &:before{
        opacity: 0.1;
      }
    }
    &:after, &:before{
      pointer-events: none;
      z-index: -1;
      content: "";
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
    }
    &:before{
      opacity: 0;
      background-color: var(--color-1);
    }
    &:after{
      transition: 0.2s ease;
      left: 10%;
      width: 80%;
      height: 1px;
      background-color: #f3f3f3;
      top: auto;
      bottom: 0;
      border-radius: 20px;
      z-index: -2;
      
    }
    &:nth-last-child(1){
      &:after{
        opacity: 0;
      }
    }
    &:nth-child(odd){
      &:before{
        // opacity: 0;
      }
    }
    &:hover{
      cursor: pointer;
      background-color: var(--color-1);
      color: white;
      &:after{
        opacity: 0;
      }
    }
  }
}


</style>
